// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"AddToCart-module--checkmark--2HPlT","stroke":"AddToCart-module--stroke--3RyBC"};